import { create } from "zustand";

import type { AdminNotification } from "@/lib/realtime";

/** Ro'yxatda saqlanadigan eng ko'p xabar. */
export const MAX_NOTIFICATIONS = 30;

export interface StoredNotification extends AdminNotification {
  read: boolean;
}

interface AdminNotificationsState {
  items: StoredNotification[];
  push: (notification: AdminNotification) => void;
  markAllRead: () => void;
  clear: () => void;
}

/**
 * Socketdan kelgan navbat xabarlari.
 *
 * SAQLANMAYDI va bu ataylab. Xabarning o'zi haqiqat manbai emas:
 * navbat allaqachon bazada turibdi — ariza `pending` holatida,
 * shikoyat `open` holatida. Xabarni `localStorage` ga yozish
 * ikkinchi, eskiradigan nusxani yaratardi: moderator arizani boshqa
 * tabda ko'rib chiqadi, qo'ng'iroqchada esa u "yangi" bo'lib
 * turaverardi. Sahifa yangilanganda ro'yxat bo'shaydi va haqiqat
 * o'sha sahifalarning o'zida qoladi.
 *
 * CHEGARA BOR: uzoq ochiq turgan panelda xabarlar cheksiz to'planib,
 * xotirani ham, ro'yxatni ham egallardi. Eng yangi
 * `MAX_NOTIFICATIONS` tasi qoladi — undan eskisi baribir navbat
 * sahifasidan o'qiladi.
 */
export const useAdminNotificationsStore = create<AdminNotificationsState>(set => ({
  items: [],

  push: notification =>
    set(state => {
      // Bir xil id ikki marta kelishi mumkin: qayta ulanishda server
      // oxirgi hodisani takrorlashi mumkin, va ro'yxatda ikkita bir
      // xil qator paydo bo'lardi.
      if (state.items.some(item => item.id === notification.id)) return state;

      return {
        items: [{ ...notification, read: false }, ...state.items].slice(0, MAX_NOTIFICATIONS),
      };
    }),

  // Ro'yxat ochilganda hammasi o'qilgan bo'ladi: qo'ng'iroqchani
  // ochgan odam ularni ko'rdi. Har birini alohida belgilash
  // moderatorga qo'shimcha ish berardi va hech qanday savolga javob
  // bermasdi.
  markAllRead: () => set(state => ({ items: state.items.map(item => ({ ...item, read: true })) })),

  clear: () => set({ items: [] }),
}));

/** O'qilmaganlar soni — qo'ng'iroqcha ustidagi raqam. */
export const unreadCount = (items: StoredNotification[]): number =>
  items.filter(item => !item.read).length;
